import {
  Product,
  ProductAccess,
  ProductAccessReason,
  ProductType,
} from '#types/generated/graphql-types';

export default function shouldShowRentButton(
  rentProduct: Product,
  access: ProductAccess
) {
  return (
    access?.allowed === false &&
    rentProduct?.type === ProductType.Rent &&
    access?.reason == ProductAccessReason.RentRequired
  );
}
